import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getCountryName = (countryCode: string | null): string => {
  const countries: { [key: string]: string } = {
    'US': 'United States',
    'CA': 'Canada',
    'MX': 'Mexico',
    'IN': 'India',
    'DE': 'Germany',
    'FR': 'France',
    'GB': 'United Kingdom',
    'IT': 'Italy',
    'ES': 'Spain',
    'PT': 'Portugal',
    'NL': 'Netherlands',
    'BE': 'Belgium',
    'CH': 'Switzerland',
    'AT': 'Austria',
    'SE': 'Sweden',
    'NO': 'Norway',
    'DK': 'Denmark',
    'FI': 'Finland',
    'IE': 'Ireland',
    'AU': 'Australia',
    'NZ': 'New Zealand',
    'JP': 'Japan',
    'KR': 'South Korea',
    'CN': 'China',
    'SG': 'Singapore',
    'MY': 'Malaysia',
    'TH': 'Thailand',
    'VN': 'Vietnam',
    'PH': 'Philippines',
    'ID': 'Indonesia',
    'BR': 'Brazil',
    'AR': 'Argentina',
    'CL': 'Chile',
    'CO': 'Colombia',
    'PE': 'Peru',
    'VE': 'Venezuela',
    'ZA': 'South Africa',
    'NG': 'Nigeria',
    'KE': 'Kenya',
    'EG': 'Egypt',
    'IL': 'Israel',
    'SA': 'Saudi Arabia',
    'AE': 'United Arab Emirates',
    'TR': 'Turkey',
    'RU': 'Russia'
  };
  
  return countries[countryCode || ''] || 'your country';
};

export const isFullySupported = (countryCode: string | null): boolean => {
  const supportedCountries = ['US', 'CA', 'MX', 'IN'];
  return supportedCountries.includes(countryCode || '');
};

export const hasWebAppSupport = (countryCode: string | null): boolean => {
  const webAppSupportedCountries = ['US', 'CA', 'MX', 'IN', 'AE'];
  return webAppSupportedCountries.includes(countryCode || '');
};

export const getPhoneNumber = (countryCode: string | null): { display: string; dial: string } => {
  switch (countryCode) {
    case 'IN':
      return {
        display: '+91 800-919-1848',
        dial: '+918009191848'
      };
    default:
      return {
        display: '1-866-520-4146',
        dial: '+18665204146'
      };
  }
}; 